import { FilesTobeSavedProps } from 'shared/interfaces/IModalForm';
import { uploadService } from 'shared/services/uploadService';

type UploadImageToS3Props = {
  filesToBeSaved: FilesTobeSavedProps[];
};

const { uploadMedia } = uploadService();

export const useImageUploadToS3 = () => {
  const { mutateAsync: mutateAsyncUploadMedia } = uploadMedia();
  const uploadImageToS3 = async ({ filesToBeSaved }: UploadImageToS3Props) => {
    // Use Promise.all to wait for all async operations to finish
    return await Promise.all(
      filesToBeSaved.map(async (file: any) => {
        if (file?.attributes && file?.id) return file;
        const formData = new FormData();
        const {
          attachment,
          file_name,
          file_width,
          file_height,
          file_type,
          file_size,
          tag_list,
          attachment_size,
          cropped_attachment,
          cropped_metadata,
          modified_metadata,
          modified_attachment,
        } = file;
        formData.set('attachment', attachment);
        formData.set('modified_attachment', modified_attachment as any);
        formData.set(
          'modified_metadata',
          JSON.stringify({
            modified_attachment_url: modified_metadata,
            cropped_attachment_url: cropped_metadata,
          }),
        );
        formData.append('cropped_attachment', cropped_attachment);
        formData.set('attachment_size', attachment_size ? attachment_size.toString() : '');
        formData.append('file_name', file_name);
        formData.append('file_type', file_type);
        formData.set('file_size', file_size);
        formData.set('file_height', file_height);
        formData.set('file_width', file_width);
        formData.append('tag_list', tag_list);
        formData.append('file_type', 'image');

        const media = await mutateAsyncUploadMedia({
          formData,
        });

        return media?.data;
      }),
    );
  };
  return { uploadImageToS3 };
};
